// removed by extract-text-webpack-plugin
module.exports = {"OnlineFormularBody":"OnlineFormularBody__11x22","StartChattingButton":"StartChattingButton__fQ4N7","StartChattingText":"StartChattingText__3hHzz","Header":"Header__19ISK"};


//////////////////
// WEBPACK FOOTER
// ./routes/OnlineFormular/style.scss
// module id = qIew
// module chunks = 0